<template>
  <div>
    <breadcrumb :items="breadcrumbs"></breadcrumb>
    <v-container fluid>
      <div class="d-flex mb-4">
        <h2>Total Animal Analytics</h2>
        <v-spacer></v-spacer>
        <v-select
          :items="titles"
          color="primary"
          item-text="text"
          item-value="value"
          dense
          outlined
          v-model="title"
          @input="changedLabel"
          class="shrink mr-2 wdt"
          placeholder="Select By category"
        ></v-select>
      </div>
      <div class="d-flex">
        <v-select
          dense
          outlined
          class="shrink mr-2 wdt"
          placeholder="Calendar"
          append-icon="mdi-filter-outline"
        >
          <!-- <v-icon>mdi-filter-outline</v-icon> -->
        </v-select>
        <v-autocomplete
          v-model="farm"
          :items="farmsList"
          item-text="name"
          item-value="farmNumber"
          dense
          append-icon="mdi-filter-outline"
          :loading="farmLoading"
          :search-input.sync="farmSearch"
          outlined
          hide-no-data
          placeholder="Farm/Herd"
          class="shrink mr-2 wdt"
        ></v-autocomplete>
        <v-autocomplete
          v-model="owner"
          :items="userList"
          item-text="name"
          item-value="userNumber"
          dense
          append-icon="mdi-filter-outline"
          :loading="userLoading"
          :search-input.sync="userSearch"
          outlined
          hide-no-data
          placeholder="owner"
          class="shrink mr-2 wdt"
        ></v-autocomplete>
        <v-btn
          type="submit"
          width="146"
          height="39"
          color="primary"
          @click="getAnimaldata()"
          >Apply</v-btn
        >
        <v-btn
          width="146"
          height="39"
          class="ml-2"
          outlined
          color="primary"
          exact
          @click="cancelData()"
        >
          {{ $t("cancel") }}</v-btn
        >
      </div>
      <v-row>
        <v-col cols="4">
          <v-card flat elevation="0" height="187px" class="px-2 py-2" outlined>
            <v-toolbar dense flat :elevation="0">
              <v-toolbar-title class="text-h6 font-weight-black"
                >Total Animals</v-toolbar-title
              >
            </v-toolbar>
            <v-divider></v-divider>
            <v-card-text class="pa-0">
              <v-list>
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title
                      class="text-h5 mt-2 mb-2 text-capitalize"
                    >
                      {{ animal.totalAnimal }}
                    </v-list-item-title>
                    <v-list-item-subtitle class="font-weight-medium">
                      {{ "Currently on Farm" }}
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col cols="8">
          <v-card flat elevation="0" class="px-2 py-2" outlined>
            <v-toolbar dense flat :elevation="0">
              <v-toolbar-title class="text-h6 font-weight-black"
                >Animal History</v-toolbar-title
              >
            </v-toolbar>
            <v-divider></v-divider>
            <v-card-text class="pa-0">
              <!-- <v-card flat>
        <v-card-title> -->
              <v-row class="elevation-0" width="">
                <v-col sm="" class="">
                  <v-list>
                    <v-list-item>
                      <v-list-item-content>
                        <v-list-item-title
                          class="text-h6 mt-2 mb-2 text-capitalize"
                        >
                          {{ animal.lastYearReg }}
                        </v-list-item-title>
                        <v-list-item-subtitle class="mb-2">
                          <v-icon
                            small
                            color="primary"
                            v-if="animal.lastYearPer >= 50"
                            >mdi-arrow-up</v-icon
                          >
                          <v-icon small color="red" v-else
                            >mdi-arrow-down</v-icon
                          >
                          {{ animal.lastYearPer }}
                        </v-list-item-subtitle>
                        <v-list-item-subtitle class="font-weight-medium">
                          {{ "Since Last Year" }}
                        </v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list>
                </v-col>
                <v-divider vertical inset></v-divider>
                <v-col sm="" class="">
                  <v-list>
                    <v-list-item>
                      <v-list-item-content>
                        <v-list-item-title
                          class="text-h6 mt-2 mb-2 text-capitalize"
                        >
                          {{ animal.lastQuaterReg }}
                        </v-list-item-title>
                        <v-list-item-subtitle class="mb-2">
                          <v-icon
                            small
                            color="primary"
                            v-if="animal.lastQuaterPer >= 50"
                            >mdi-arrow-up</v-icon
                          >
                          <v-icon small color="red" v-else
                            >mdi-arrow-down</v-icon
                          >
                          {{ animal.lastQuaterPer }}
                        </v-list-item-subtitle>
                        <v-list-item-subtitle class="font-weight-medium">
                          {{ "Since Last Quarter" }}
                        </v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list>
                </v-col>
                <v-divider vertical inset></v-divider>
                <v-col sm="" class="">
                  <v-list>
                    <v-list-item>
                      <v-list-item-content>
                        <v-list-item-title
                          class="text-h6 mt-2 mb-2 text-capitalize"
                        >
                          {{ animal.lastMonthReg }}
                        </v-list-item-title>
                        <v-list-item-subtitle class="mb-2">
                          <v-icon
                            small
                            color="primary"
                            v-if="animal.lastMonthPer >= 50"
                            >mdi-arrow-up</v-icon
                          >
                          <v-icon small color="red" v-else
                            >mdi-arrow-down</v-icon
                          >
                          {{ animal.lastMonthPer }}
                        </v-list-item-subtitle>
                        <v-list-item-subtitle class="font-weight-medium">
                          {{ "Since Last Month" }}
                        </v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list>
                </v-col>
                <v-divider vertical inset></v-divider>
                <v-col sm="" class="">
                  <v-list>
                    <v-list-item>
                      <v-list-item-content>
                        <v-list-item-title
                          class="text-h6 mt-2 mb-2 text-capitalize"
                        >
                          {{ animal.lastWeekReg }}
                        </v-list-item-title>
                        <v-list-item-subtitle class="mb-2">
                          <v-icon
                            small
                            color="primary"
                            v-if="animal.lastWeekPer >= 50"
                            >mdi-arrow-up</v-icon
                          >
                          <v-icon small color="red" v-else
                            >mdi-arrow-down</v-icon
                          >
                          {{ animal.lastWeekPer }}
                        </v-list-item-subtitle>
                        <v-list-item-subtitle class="font-weight-medium">
                          {{ "Since Last Week" }}
                        </v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list>
                </v-col>
              </v-row>
              <!-- </v-card-title>
      </v-card> -->
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <v-card flat elevation="0" class="mt-5 px-2 py-2" outlined>
        <v-toolbar dense flat :elevation="0">
          <v-toolbar-title class="text-h6 font-weight-black"
            >Daily Animal Updates</v-toolbar-title
          >
          <v-spacer></v-spacer>

          <span class="mt-5 mr-2">
            <v-menu
              v-model="startmenu"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="startDate"
                  class="shrink"
                  append-icon="mdi-calendar"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                  outlined
                  dense
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="startDate"
                @input="startmenu = false"
              ></v-date-picker>
            </v-menu>
          </span>
          <span>TO</span>
          <span class="mt-5 ml-2">
            <v-menu
              v-model="endmenu"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="endDate"
                  class="shrink"
                  append-icon="mdi-calendar"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                  outlined
                  dense
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="endDate"
                @input="endmenu = false"
              ></v-date-picker>
            </v-menu>
          </span>
          <v-btn color="primary" dark class="ml-2 mb-2" @click="updateChart()">
            Apply
          </v-btn>
          <v-icon color="primary" dark class="ml-2" @click="getAnimaldaily()"
            >mdi-reload</v-icon
          >
          <v-icon class="float-right">mdi-dots-vertical</v-icon>
        </v-toolbar>
        <v-divider></v-divider>
        <v-card-text class="mt-5 pa-0">
          <template>
            <bar-chart
              id="barChart"
              v-if="loaded"
              :chartdata="chartData"
              :options="options"
            ></bar-chart>
            <v-card v-else class="px-5 mt-5">
              <v-card-text class="text-center">
                <v-avatar size="135"> </v-avatar>
                <p class="text-h4 font-weight-bold">No Record Found</p>
                <p>No Animals are Registered for this Farm</p>
              </v-card-text>
            </v-card>
          </template>
        </v-card-text>
      </v-card>

      <v-card flat elevation="0" class="mt-5 px-2 py-2" outlined>
        <v-toolbar dense flat :elevation="0">
          <v-toolbar-title class="text-h6 font-weight-black"
            >Weekly Analytics</v-toolbar-title
          >
          <v-spacer></v-spacer>

          <span class="mt-5 mr-2">
            <v-menu
              v-model="startmenuWeekly"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="startDateWeekly"
                  class="shrink"
                  append-icon="mdi-calendar"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                  outlined
                  dense
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="startDateWeekly"
                @input="startmenuWeekly = false"
              ></v-date-picker>
            </v-menu>
          </span>
          <span>TO</span>
          <span class="mt-5 ml-2">
            <v-menu
              v-model="endmenuWeekly"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="endDateWeekly"
                  class="shrink"
                  append-icon="mdi-calendar"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                  outlined
                  dense
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="endDateWeekly"
                @input="endmenuWeekly = false"
              ></v-date-picker>
            </v-menu>
          </span>
          <v-btn
            color="primary"
            dark
            class="ml-2 mb-2"
            @click="updateChartWeek()"
          >
            Apply
          </v-btn>
          <v-icon color="primary" dark class="ml-2" @click="getAnimalweekly()"
            >mdi-reload</v-icon
          >
          <v-icon class="float-right">mdi-dots-vertical</v-icon>
        </v-toolbar>
        <v-divider></v-divider>
        <v-card-text class="mt-5 pa-0">
          <template>
            <line-chart
              v-if="loadedWeek"
              :chartdata="data"
              :options="lineoptions"
            ></line-chart>
            <v-card v-else class="px-5 mt-5">
              <v-card-text class="text-center">
                <v-avatar size="135"> </v-avatar>
                <p class="text-h4 font-weight-bold">No Record Found</p>
                <p>No Animals are Registered for this Farm</p>
              </v-card-text>
            </v-card>
          </template>
        </v-card-text>
      </v-card>
      <!-- <v-card flat elevation="0" class="mt-5 px-2 py-2" outlined height="">
            <v-toolbar dense flat :elevation="0">
              <v-toolbar-title class="text-h6 font-weight-black">Weekly Analytics</v-toolbar-title>
            </v-toolbar>
            <v-divider></v-divider>
            <v-card-text class="mt-5 pa-0"> 
              <v-row width="100%">
                <v-col cols="" width="">
                 <template >
              <doughnut-chart :chartdata="studdata" :options="studoptions"></doughnut-chart>
              </template>
                </v-col>
                 <v-col cols="" width="">
                 <template >
              <doughnut-chart :chartdata="studdata" :options="studoptions"></doughnut-chart>
              </template>
                </v-col>
                 <v-col cols="" width="">
                 <template >
              <doughnut-chart :chartdata="studdata" :options="studoptions"></doughnut-chart>
              </template>
                </v-col>
                 <v-col cols="" width="">
                 <template >
              <doughnut-chart :chartdata="studdata" :options="studoptions"></doughnut-chart>
              </template>
                </v-col>
                <v-col cols="" width="">
                 <template >
              <doughnut-chart :chartdata="studdata" :options="studoptions"></doughnut-chart>
              </template>
                </v-col>
              </v-row>
              </v-card-text>
          </v-card> -->
      <!-- <v-card flat elevation="0" class="mt-5 px-2 py-2" outlined height="">
            <v-toolbar dense flat :elevation="0">
              <v-toolbar-title class="text-h6 font-weight-black">Number of Sick Animals By Disease</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-icon  color="primary"
                    dark
                   
                    class="ml-2">mdi-reload</v-icon>
                    <v-icon class="float-right">mdi-dots-vertical</v-icon>
            </v-toolbar>
            <v-divider></v-divider>
            <v-card-text class="mt-5 pa-0"> 
              <template >
              <bar-chart :chartdata="sickData" :options="sickoptions"></bar-chart>
              </template> 
              </v-card-text>
          </v-card> -->
      <v-card flat elevation="0" class="mt-5 px-2 py-2" outlined height="">
        <v-toolbar dense flat :elevation="0">
          <v-toolbar-title class="text-h6 font-weight-black"
            >Animal Disease Record</v-toolbar-title
          >
          <v-spacer></v-spacer>
          <v-icon
            color="primary"
            dark
            class="ml-2"
            @click="this.getAnimalDiseaseData()"
            >mdi-reload</v-icon
          >
          <v-icon class="float-right">mdi-dots-vertical</v-icon>
        </v-toolbar>
        <v-divider></v-divider>
        <v-card-text class="mt-5 pa-0">
          <v-data-table
            :headers="headers"
            :items="anidata"
            v-model="selected"
            show-select
            item-key="animalNumber"
            :items-per-page="5"
            :loading="loading"
            loading-text="Loading Diseases... Please wait"
            hide-default-footer
            :footer-props="{
              'items-per-page-options': [5, 10, 25],
              'show-first-last-page': true,
              'show-current-page': true,
              'items-per-page-text': 'Farms per page',
            }"
            :options.sync="tableOptions"
            :server-items-length="totalDiseases"
          >
            <template v-slot:top>
              <div class="d-flex mt-5">
                <v-text-field
                  prepend-inner-icon="mdi-magnify"
                  outlined
                  height="5px"
                  placeholder="Search"
                  dense
                  v-model="search"
                  @click:append="searchAnimals"
                  @input="resetSearchOnEmpty"
                  class="shrink"
                ></v-text-field>
                <v-btn
                  :disabled="search.length < 1"
                  color="primary"
                  height="40"
                  width="40"
                  max-width="40"
                  outlined
                  class="ml-8"
                  @click="searchAnimals"
                >
                  <v-icon>mdi-filter-outline</v-icon>
                </v-btn>
                <v-spacer></v-spacer>
                <div class="py-1 title">
                  {{ from }} - {{ to }} of {{ totalDiseases }}
                </div>
                <v-btn
                  class="mx-2"
                  fab
                  small
                  outlined
                  color="primary"
                  :disabled="tableOptions.page <= 1"
                  @click="pageChange(false)"
                >
                  <v-icon dark> mdi-chevron-left </v-icon>
                </v-btn>
                <v-btn
                  class="mx-2"
                  fab
                  small
                  outlined
                  color="primary"
                  :disabled="tableOptions.page >= totalPages"
                  @click="pageChange(true)"
                >
                  <v-icon dark> mdi-chevron-right </v-icon>
                </v-btn>
                <!-- <v-btn
                                class="mx-2"
                                fab
                                small
                                outlined
                                color="primary"
                                disabled
                            >
                                <v-icon dark>
                                    mdi-cog-outline
                                </v-icon>
                            </v-btn> -->
              </div>
            </template>
            <template v-if="anidata.length > 0" v-slot:body="{ items }">
              <tbody>
                <tr
                  v-for="item in items"
                  :key="item.animalNumber"
                  @mouseover="selectItem(item)"
                  @mouseleave="unSelectItem()"
                  style="position: relative; width: 0; height: 0"
                >
                  <td>
                    <v-checkbox
                      multiple
                      v-model="selected"
                      :value="item"
                      style="margin: 0px; padding: 0px"
                      hide-details
                      v-on:click.stop=""
                    />
                  </td>
                  <td>{{ item.animalNumber }}</td>
                  <td>{{ item.attendingVeterinarian }}</td>
                  <td>{{ item.diagnosis }}</td>
                  <td>{{ item.drugName }}</td>
                  <td>{{ item.drugWithdrawPeriod }}</td>
                  <td>{{ item.treatmentDate }}</td>
                  <td>{{ item.recoveryStatus }}</td>
                  <div
                    style="position: absolute; right: 10px; top: 4px"
                    v-if="item === selectedItem"
                  ></div>
                </tr>
              </tbody>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-container>
  </div>
</template>
<script>
import loadingMixin from "@/mixins/LoadingMixin";
import FarmService from "@/_services/farmService.js";
import BarChart from "./BarChart.vue";
import LineChart from "./LineChart.vue";
import HealthReport from "@/_services/AnalyticsService";
export default {
  components: {
    BarChart,
    LineChart,
  },
  async mounted() {
    document.title = "Animal Analytics";
    // await this.animalData()
    await this.getAnimaldaily();
    await this.getAnimaldata();
    await this.getAnimalweekly();
  },
  watch: {
    async farmSearch(val) {
      await this.searchFarm(val);
    },
    async userSearch(val) {
      await this.searchUser(val);
    },
    tableOptions: {
      handler() {
        this.getAnimalDiseaseData();
      },
      deep: true,
    },
    // handler() {
    //   this.getAnimaldaily();
    // },
  },
  data: () => ({
    startmenu: false,
    endmenu: false,
    startmenuWeekly: false,
    endmenuWeekly: false,
    startDateWeekly: "2021-11-11",
    endDateWeekly: "2021-11-15",
    startDate: "2021-11-11",
    endDate: "2022-04-15",
    farmLoading: false,
    farmSearch: "",
    farmsList: [],
    loaded: false,
    userLoading: false,
    userSearch: "",
    search: "",
    userList: [],
    owner: "",
    farm: "",
    animal: {},
    anidata: [],
    result: [],
    from: "",
    totalPages: "",
    tableOptions: {},
    to: "",
    selectedItem: "",
    totalDiseases: 0,
    loading: false,
    loadedWeek: false,
    chartData: {
      labels: [],
      datasets: [
        {
          label: "<1 Years",
          backgroundColor: "#489E16",
          data: [],
          barPercentage: 2,
          barThickness: 7,
          maxBarThickness: 10,
          minBarLength: 2,
        },
        {
          label: "<2 Years",
          backgroundColor: "#FFB443",
          data: [],
          barPercentage: 2,
          barThickness: 7,
          maxBarThickness: 10,
          minBarLength: 2,
        },
        {
          label: "<3 Years",
          backgroundColor: "#135B00",
          data: [],
          barPercentage: 2,
          barThickness: 7,
          maxBarThickness: 10,
          minBarLength: 2,
        },
        {
          label: "<4 Years",
          backgroundColor: "#1F5D51",
          data: [],
          barPercentage: 2,
          barThickness: 7,
          maxBarThickness: 10,
          minBarLength: 2,
        },
      ],
    },
    options: {
      tooltips: {
        displayColors: true,
        callbacks: {
          mode: "x",
        },
      },
      scales: {
        xAxes: [
          {
            gridLines: {
              display: false,
            },
          },
        ],
        yAxes: [
          {
            // stacked: true,
            ticks: {
              beginAtZero: true,
            },
            type: "linear",
          },
        ],
      },
      responsive: true,
      maintainAspectRatio: false,
      legend: { position: "top" },
    },
    data: {
      labels: [],
      datasets: [
        {
          label: "Last Week",
          backgroundColor: "#489E16",
          borderColor: "#489E16",
          fill: false,
          data: [],
        },
        {
          label: "This Week",
          backgroundColor: "#FFB443",
          borderColor: "#FFB443",
          fill: false,
          data: [],
        },
      ],
    },
    headers: [
      {
        text: "Animal ID",
        align: "start",
        sortable: false,
        value: "animalNumber",
      },
      { text: "veterinarian Name", value: "attendingVeterinarian" },
      { text: "Diagnosis Name", value: "diagnosis" },
      { text: "Drug Name", value: "drugName" },
      { text: "DrugWithdraw Period", value: "drugWithdrawPeriod" },
      { text: "Treatment Date", value: "treatmentDate" },
      // { text: "Recovery Status", value: "recoveryStatus" },
    ],
    lineoptions: {
      responsive: true,
      maintainAspectRatio: false,
      title: {
        display: true,
        text: "line chart",
      },
      scales: {
        xAxes: [
          {
            display: true,
            scaleLabel: {
              display: true,
              labelString: "Date",
            },
          },
        ],
        yAxes: [
          {
            display: true,
            //type: 'logarithmic',
            scaleLabel: {
              display: true,
              labelString: "Index Returns",
            },
            ticks: {
              min: 0,
              max: 500,
              // forces step size to be 5 units
              // stepSize: 100
            },
          },
        ],
      },
    },
    //    studdata: {
    //   datasets: [{
    //     label: 'This Week',
    //     data: [70,100],
    //     backgroundColor: [
    //       "#1F5D51",
    //     ],
    //   }]
    // },
    // studoptions: {
    //   cutoutPercentage: 80,
    //   elements: {
    //     center: {
    //       text: '15% Stud Animals',
    //       color: '#FF6384', // Default is #000000
    //       fontStyle: 'Arial', // Default is Arial
    //       sidePadding: 20, // Default is 20 (as a percentage)
    //       minFontSize: 25, // Default is 20 (in px), set to false and text will not wrap.
    //       lineHeight: 25 // Default is 25 (in px), used for when text wraps
    //     }
    //   },
    //   responsive: true,
    //   maintainAspectRatio: false,
    //   legend: {
    //     display: false
    //   }
    // },
    sickData: {
      labels: ["a", "b", "c", "d", "e", "f", "g", "h", "i"],
      datasets: [
        {
          label: "last Week",
          backgroundColor: "#489E16",
          data: [12, 59, 5, 56, 58, 12, 59, 65, 51],
        },
        {
          label: "This Week",
          backgroundColor: "#FFB443",
          data: [12, 59, 5, 56, 58, 12, 59, 12, 74],
        },
      ],
    },
    sickoptions: {
      tooltips: {
        displayColors: true,
        callbacks: {
          mode: "x",
        },
      },
      scales: {
        xAxes: [
          {
            gridLines: {
              display: false,
            },
          },
        ],
        yAxes: [
          {
            // stacked: true,
            ticks: {
              beginAtZero: true,
            },
            type: "linear",
          },
        ],
      },
      responsive: true,
      maintainAspectRatio: false,
      legend: { position: "top" },
    },
    selected: [],
    title: "animalAnalytics",
    titles: [
      {
        text: "Calf",
        value: "calfAnalytics",
      },
      {
        text: "Milk Production",
        value: "milkAnalytics",
      },
      {
        text: "Total Animals",
        value: "animalAnalytics",
      },
      {
        text: "Milking Animals",
        value: "milkingAnalytics",
      },
      {
        text: "Stud Animals",
        value: "studAnalytics",
      },
      {
        text: "Total Milk Type",
        value: "milktypeAnalytics",
      },
    ],
    breadcrumbs: [
      {
        text: "Dashboard",
        disabled: false,
        to: "/",
      },
      {
        text: "Analytics",
        disabled: true,
      },
    ],
    route: "",
  }),
  methods: {
    changedLabel(event) {
      this.route = event;
      console.log(this.route);
      this.$router.push({
        name: `${this.route}`,
      });
    },
    async updateChart() {
      this.loaded = false;
      console.log(false);
      this.getAnimaldaily();
    },
    async updateChartWeek() {
      this.loadedWeek = false;
      console.log(false);
      this.getAnimalweekly();
    },
    searchFarm(val) {
      if (val == "" || val == null) return;
      this.farmsLoading = true;
      FarmService.searchFarms(val)
        .then(res => {
          console.log(res);
          this.farmsList = res.data.farms;
        })
        .catch(err => {
          console.log(err);
          // this.users = [];
        })
        .finally(() => (this.farmsLoading = false));
    },
    selectItem(item) {
      this.selectedItem = item;
    },
    unSelectItem() {
      this.selectedItem = false;
    },
    cancelData() {
      this.owner = "";
      this.farm = "";
    },
    searchUser(val) {
      if (val == "" || val == null) return;
      this.userLoading = true;
      FarmService.searchUsers(val)
        .then(res => {
          console.log(res);
          this.userList = res.data.users;
        })
        .catch(err => {
          console.log(err);
          // this.users = [];
        })
        .finally(() => (this.userLoading = false));
    },
    async getAnimaldata() {
      this.startLoading();
      console.log(this.farm);
      await HealthReport.getAnimaldata(this.farm, this.owner)
        .then(res => {
          this.animal = res.data;
          console.log(this.animal);
          this.stopLoading();
        })
        .catch(err => {
          console.log(err);
          this.stopLoading();
        });
    },
    async getAnimaldaily() {
      this.startLoading();
      await HealthReport.getAnimaldaily(this.startDate, this.endDate, this.farm)
        .then(async res => {
          console.log(res.data);
          this.result = res.data;
          if (this.result.length > 0) {
            res.data.reverse().forEach(c => {
              // console.log(c)
              if (c.age < 1) {
                this.chartData.datasets[0].data.push(c.count);
              } else if (c.age < 2) {
                this.chartData.datasets[1].data.push(c.count);
              } else if (c.age < 3) {
                this.chartData.datasets[2].data.push(c.count);
              } else {
                this.chartData.datasets[3].data.push(c.count);
              }
            });

            this.chartData.labels = [
              ...new Set(res.data.map(item => item.createdAt)),
            ];
            this.loaded = true;
          }
          this.stopLoading();
        })
        .catch(err => {
          console.log(err);
          this.stopLoading();
        });
    },
    async getAnimalweekly() {
      this.startLoading();
      await HealthReport.getAnimalweekly(
        this.startDateWeekly,
        this.endDateWeekly,
        this.farm
      )
        .then(async res => {
          console.log("weekly", res);

          if (res.data.dailyRows.length > 0 || res.data.weeklyRows.length > 0) {
            await res.data.dailyRows.reverse().forEach(c => {
              this.data.datasets[1].data.push(c.count);
            });
            await res.data.weeklyRows.reverse().forEach(c => {
              this.data.datasets[0].data.push(c.count);
            });

            if (res.data.dailyRows.length > 0) {
              this.data.labels = [
                ...new Set(res.data.dailyRows.map(item => item.createdAt)),
              ];
              console.log(this.data.labels);
              console.log(this.data.datasets);
              this.loadedWeek = true;
            } else {
              this.data.labels = [
                ...new Set(res.data.weeklyRows.map(item => item.createdAt)),
              ];
              this.loadedWeek = true;
            }
          }
          this.stopLoading();
        })
        .catch(err => {
          console.log(err);
          this.stopLoading();
        });
    },
    getAnimalDiseaseData() {
      this.getDiseaseData();
    },
    getDiseaseData() {
      this.loading = true;
      HealthReport.getAnimalDisease(this.tableOptions, this.search)
        .then(res => {
          console.log(res);
          if (res.success) {
            this.anidata = res.data.healthRecord.rows;
            this.currentrows = res.data.healthRecord.num_rows;
            this.totalDiseases = res.data.healthRecord.total_rows;
            this.totalPages = Math.ceil(
              this.totalDiseases / this.tableOptions.itemsPerPage
            );
            this.from =
              (this.tableOptions.page - 1) * this.tableOptions.itemsPerPage + 1;
            this.to =
              this.tableOptions.page * this.tableOptions.itemsPerPage -
              (this.tableOptions.itemsPerPage - res.data.healthRecord.num_rows);
            this.loading = false;
          }
        })
        .catch(err => {
          console.log(err);
          this.loading = false;
        });
    },
    pageChange(t) {
      if (t) this.tableOptions.page = this.tableOptions.page + 1;
      else this.tableOptions.page = this.tableOptions.page - 1;
      this.getAnimalDiseaseData();
    },
    searchAnimals() {
      if (this.search == "") return;

      this.tableOptions.page = 1;
      this.getAnimalDiseaseData();
    },
    resetSearchOnEmpty() {
      if (this.search === "") return;

      this.tableOptions.page = 1;
      this.getAnimalDiseaseData();
    },
  },
  mixins: [loadingMixin],
};
</script>
<style lang="scss" scoped>
::v-deep .wdt {
  width: 175px;
}
.stackSheet {
  position: relative;
}
.stackSpark {
  position: absolute;
  top: 0;
  left: 0;
}
</style>
